import React, { memo, useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { changeGenieProjectAccessAssistants, changeProject, getProject } from '../../../redux/projects/projectsActions';
import { resetEditProjectPage } from '../../../redux/projects/projectsReducer';
import NameSection from '../name/NameSection';
import ShareSection from '../share/ShareSection';
import AccessUsersSection from '../access-users/AccessUsersSection';
import AssignedAssistantsSection from './components/assignedAssistants/AssignedAssistantsSection';
import { getGenieBrandOptions } from '../../../redux/genie/genieActions';
import { PROJECT_TYPES } from '../../../constants';

import scss from './EditGenie.module.scss';

const EditGenie = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleSaveNameSection = ({ id, editProject, values }) => {
    const { projectName, brand } = values;

    dispatch(changeProject({ id, projectType: editProject.projectType, values: { projectName, brand } }));
  };

  const handleChangeAccessAssistants = ({ id, activeAllAssistants }) => {
    dispatch(
      changeGenieProjectAccessAssistants({
        id,
        activeAllAssistants,
        projectType: PROJECT_TYPES.GENIE,
      }),
    );
  };

  useEffect(() => {
    dispatch(getProject({ id }));
    dispatch(getGenieBrandOptions());

    return () => {
      dispatch(resetEditProjectPage());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.pageWrapper}>
      <NameSection onSubmit={handleSaveNameSection} />
      <ShareSection />
      <AssignedAssistantsSection onChangeAccessAssistants={handleChangeAccessAssistants} />
      <AccessUsersSection />
    </div>
  );
};

export default memo(EditGenie);
